export const RUN_LIST_NAVIGATION: any = {
    createOptions: ['new'],
    helpUrl: '/platform/proxy/binary/userGuide'
};
